import axios from 'axios';

const getSingleCustomerPayment = async (token, id) => {
  const url = `/payments/single?id=${id ? id : null}`;
  try {
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token,
        lang: 'ar'
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getSingleCustomerPayment;
